import React from "react";
import "./Message.scss";

const Message = ({ message, textColor, from }) => {
  const messageStyle = {
    color: textColor || undefined,
    fontSize: from === "memory" ? "1.5rem" : undefined,
    marginTop: from === "memory" ? "100px" : undefined,
  };

  return (
    <div className="Message" style={messageStyle}>
      {message}
    </div>
  );
};

export default Message;
